// Linked sales documents carry the Employee (salesperson) and Job / Project
// forward (2026-10-28):
//   Quotation → Sale Order → Delivery Challan → Sale Invoice / Non-Tax Sale Invoice
//   Sale Order → Sale Invoice / Non-Tax Sale Invoice
//   Sale Invoice → Sale Return, Non-Tax Sale Invoice → Non-Tax Sale Return
// Only values filled on the linked document are carried — a blank there keeps
// whatever is already chosen (e.g. the customer's default salesperson). The
// field stays editable. Firebase cost: none (the linked document is already loaded).
export const carryEmployeeJob = (src) => {
  const out = {};
  if (src && src.employeeId) { out.employeeId = src.employeeId; out.employeeName = src.employeeName || ''; }
  if (src && src.jobId) { out.jobId = src.jobId; out.jobName = src.jobName || ''; }
  return out;
};

// HS Code on sales documents (2026-11-02): Quotation → Sale Order → Delivery
// Challan → Sale Invoice → Sale Return. A linked line keeps its own HS Code; a
// line saved before HS Code was carried falls back to the item's HS Code.
// Returns {} when there is none, so documents without HS Codes save as before.
export const hsCodePatch = (line, item) => {
  const hs = String((line && line.hsCode) || (item && item.hsCode) || '').trim();
  return hs ? { hsCode: hs } : {};
};

// Customer PO (2026-11-02): Sale Order → Delivery Challan → Sale Invoice /
// Non-Tax Sale Invoice (and Sale Order → invoice directly).
export const customerPOOf = (d) => String((d && d.customerPO) || '').trim();
// Several challans on one invoice: each PO once, in order ("PO-101, PO-102").
export const joinCustomerPOs = (list) => [...new Set((list || []).map(s => String(s || '').trim()).filter(Boolean))].join(', ');
